import styled from 'styled-components';

interface LabelProps {
  color?: string;
}

export default styled.div<LabelProps>`
  border-radius: 100px;
  padding: 5px 10px;
  background-color: ${(props) => {
    switch (props.color) {
      case 'green':
        return props.theme.wnn_bg_green;
      case 'yellow':
        return props.theme.wnn_bg_yellow;
      case 'purple':
        return props.theme.wnn_bg_purple;
      case 'red':
        return props.theme.wnn_bg_red;
      case 'blue':
        return props.theme.wnn_bg_blue;
      case 'orange':
        return props.theme.wnn_bg_orange;
      case 'gray':
        return props.theme.wnn_bg_gray;
      case 'brown':
        return props.theme.wnn_bg_brown;
      case 'lightBlue':
        return props.theme.wnn_bg_lightBlue;
      case 'yellowgreen':
        return props.theme.wnn_bg_yellowgreen;
      case 'dark':
        return props.theme.darkText;
      case 'alert':
        return props.theme.wnn_alert;
      default:
        return 'none';
    }
  }};
  color: ${(props) => {
    switch (props.color) {
      case 'green':
        return props.theme.wnn_text_green;
      case 'yellow':
        return props.theme.wnn_text_yellow;
      case 'purple':
        return props.theme.wnn_text_purple;
      case 'red':
        return props.theme.wnn_text_red;
      case 'blue':
        return props.theme.wnn_text_blue;
      case 'orange':
        return props.theme.wnn_text_orange;
      case 'gray':
        return props.theme.wnn_text_gray;
      case 'brown':
        return props.theme.wnn_text_brown;
      case 'lightBlue':
        return props.theme.wnn_text_lightBlue;
      case 'yellowgreen':
        return props.theme.wnn_text_yellowgreen;
      case 'dark':
        return props.theme.dark;
      case 'alert':
        return props.theme.white;
      default:
        return 'none';
    }
  }};
`;
